import { TextField } from "@mui/material";
import React, { useContext } from "react";
import {BrandContext} from "../../../contexts/BrandContext";

export default function CustomTextField(props) {


    const brandContext = useContext(BrandContext);

    const extendProps = {...props};
    const {onChange:additionalOnChange} = props;
    const filterFields = ['formik','formFields','fieldName','onChange'];
    filterFields.forEach(key => delete extendProps[key]);
    
    const fieldProps = props.formFields[props.fieldName];
    const {
        nullToBlankString=false
    } = fieldProps;

    const type = ('type' in props.formFields[props.fieldName] ? props.formFields[props.fieldName].type : 'text');
    const defaultField = {
        submitOnEnter: false
    };
    const runningField = {defaultField, ...props.formFields[props.fieldName]};
    let displayValue = props.formik.values[props.fieldName];
    if(nullToBlankString){
        if(displayValue === null || displayValue === 'null'){
            displayValue = '';
        }
    }

    return (
        <TextField
            autoFocus
            margin="dense"
            id={props.fieldName}
            value={displayValue}
            onChange={props.formik.handleChange}
            error={Boolean(props.formik.touched[props.fieldName] && props.formik.errors[props.fieldName])}
            helperText={props.formik.errors[props.fieldName]}
            label={props.fieldName in props.formFields ? brandContext.textContent[props.formFields[props.fieldName].label] : ''}
            onKeyUp = {(e) => {
                if(runningField.submitOnEnter){
                    if (e.key === 'Enter') {
                        runningField.submitOnEnter();
                    }
                }
            }}
            
            fullWidth
            variant="standard"
            {...extendProps}
        />
    );


}